export const SET_LOADING_PLANS = 'SET_LOADING_PLANS'
export const SET_ERROR_PLANS = 'SET_ERROR_PLANS'
export const SET_PLANS_ITEMS = 'SET_PLANS_ITEMS'
export const SET_PLANS_DESCRIPTION = 'SET_PLANS_DESCRIPTION'

export const SET_FREE_PLAN_LOADING = 'SET_FREE_PLAN_LOADING'
export const SET_FREE_PLAN_ERROR = 'SET_FREE_PLAN_ERROR'

export const RESTE_ALL_PLANS_DATA_APP = 'RESTE_ALL_PLANS_DATA_APP'